import React, { useEffect, useRef } from 'react'

import AiMarkdown from '../../workspace/components/AiMarkdown'
import { filteredText } from './experimentOverviewStats'

const clock = (time) => new Date(time).toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' })

const bubble = (mine) => ({
  maxWidth: '78%',
  padding: '8px 12px',
  borderRadius: '10px',
  background: mine ? '#dbeafe' : '#f3f4f6',
  color: '#111',
  fontSize: '14px',
  lineHeight: 1.45,
  overflowWrap: 'anywhere',
})
const meta = { fontSize: '12px', color: '#6b7280', margin: '0 2px 3px 2px' }
const inlineCode = { fontFamily: 'monospace', fontSize: '0.92em', background: 'rgba(0, 0, 0, 0.06)', borderRadius: '4px', padding: '0 4px' }

// A card's text with its code names (`copy2`) as code, as the student's card shows them.
const withCode = (text) =>
  String(text ?? '')
    .split(/(`[^`\n]+`)/)
    .map((part, index) =>
      part.length > 2 && part.startsWith('`') && part.endsWith('`') ? (
        <code key={index} style={inlineCode}>
          {part.slice(1, -1)}
        </code>
      ) : (
        part
      )
    )

// A student's conversation with the AI, in the experiment Overview's student dialog: their
// questions on the right, the AI's replies on the left under the name of what wrote them ('AI',
// or the Code Coach chat's 'Code Coach' / 'Evidence Checker'), a CC-M card and the student's
// answer to it, and a line for a request that got no reply or a card skipped or cancelled. Oldest
// first and scrolled to the latest; every text is shown through the Overview's word filter
// (filteredText), the AI's as Markdown, as the student's chat shows it.
//   items: experimentOverviewStats.studentConversation's; label: the student's ('Student N').
export default function StudentConversation({ items, label }) {
  const listRef = useRef(null)
  const lastKey = items.length ? items[items.length - 1].key : null
  // To the latest when the tab opens and when a message arrives with a poll.
  useEffect(() => {
    if (listRef.current) listRef.current.scrollTop = listRef.current.scrollHeight
  }, [lastKey])

  if (!items.length) return <p style={{ fontSize: '14px', color: '#6b7280', margin: '8px 0' }}>No messages with the AI yet.</p>

  const questions = items.filter((item) => item.who === 'student').length
  return (
    <>
      <p style={{ fontSize: '13px', color: '#6b7280', margin: '0 0 8px 0' }}>
        {questions} {questions === 1 ? 'message' : 'messages'} from the student · latest at {clock(items[items.length - 1].at)}
      </p>
      <div
        ref={listRef}
        role="log"
        aria-label={`${label}'s conversation`}
        style={{ maxHeight: '60vh', overflowY: 'auto', display: 'flex', flexDirection: 'column', gap: '10px', padding: '4px 2px' }}>
        {items.map((item) => {
          if (item.who === 'notice') {
            return (
              <div key={item.key} style={{ alignSelf: 'center', fontSize: '12px', color: '#6b7280' }}>
                {item.text} · {clock(item.at)}
              </div>
            )
          }
          if (item.who === 'card') {
            return (
              <div key={item.key} style={{ alignSelf: 'flex-start', maxWidth: '78%' }}>
                <div style={meta}>Card · {clock(item.at)}</div>
                <div style={{ ...bubble(false), background: '#ffffff', border: '1px solid #bfdbfe' }}>{withCode(filteredText(item.text))}</div>
              </div>
            )
          }
          const mine = item.who === 'student'
          return (
            <div key={item.key} style={{ alignSelf: mine ? 'flex-end' : 'flex-start', display: 'flex', flexDirection: 'column', alignItems: mine ? 'flex-end' : 'flex-start', maxWidth: '100%' }}>
              <div style={meta}>
                {mine ? label : item.name}
                {mine && item.name ? ` · ${item.name}` : ''} · {clock(item.at)}
              </div>
              {mine ? (
                <div style={bubble(true)}>
                  <span style={{ whiteSpace: 'pre-wrap' }}>{filteredText(item.text)}</span>
                </div>
              ) : (
                // The reply's own card, as the student's chat draws it (AiMarkdown).
                <div style={{ maxWidth: '78%', fontSize: '14px' }}>
                  <AiMarkdown text={filteredText(item.text)} />
                </div>
              )}
            </div>
          )
        })}
      </div>
    </>
  )
}
